import { FeatureTypes } from "entity-app/constants";
import { isNetworkAvailable } from "utils/utils";

export const PartnerBaseRoute = "/partner";
export const MAX_NUMBER_OF_FETCH_ITEM = 8; // For fetching one-by-one submittal/material data for log page

export const colorCode = {
  white: "white",
  error: "#FF3535",
  success: "#65D154",
  grey: "#b1b1b1",
  process: "#00000033",
  lightGrey: "#dedede",
  fileName: "#CCCCCC",
  orange: "#FFA41B"
};

export const ErrorMessages = {
  RevisionMode: "Go to the latest revision to edit this information.",
  PermissionNotGranted: "You do not have permission to take this action.",
  EmailRequired: "Please enter a valid email ID",
  EmailInvalid: "Please enter a valid email ID",
  EmailAlreadyExist: "User already Exists",
  EmailProjectUserExist: "Project User Exists",
  PasswordEmptyCheck: "Please enter a valid password.",
  PasswordRequired:
    "Password should be of minimum 12 characters, contain at least 1 uppercase, 1 lower case and 1 special character.",
  ConfirmPasswordRequired: "Passwords do not match",
  AssigneeRole: "Please Select Assignee Role",
  AssigneeEmail: "Please enter an Assignee Email",
  AssigneeEmailRequired: "Please enter a valid email",
  AssigneeName: "Please enter an Assignee Name",
  FirstName: "Please enter first name",
  LastName: "Please enter last name",
  PhoneNumber: "Please enter a valid phone number",
  CompanyNameRequired: "Please enter the name of company",
  CompanySelectionRequired: "Please select a company",
  OrgRequired: "Please enter the name of organization",
  EmailSentMsg:
    "Email link to reset the password will be sent if a valid and registered email address is entered",
  CreatedAccount: "Please check your email for a link to create your account",
  PasswordSetMsg: "Password has been successfully set.",
  CompanyNameExist: "Company already exists.",
  CompanyNameReqd: "Please enter the name of company.",
  Name: "Please enter name",
  ProjectRole: "Please assign project role to user.",
  SubscriptionRole: "Please assign role to user.",
  SubscriptionReqd: "Please enter subscription name.",
  CompanyUpdatedMsg: "Company details updated successfully",
  CompanyUpdateFailedMsg: "Unable to update company details.",
  SelectUserMsg: "Please select user",
  CalendarNameMsg: "Please enter calendar name",
  HolidayCountryNameMsg: "Please enter country name",
  HolidayDateMsg: "Please select holiday date",
  HolidayNameMsg: "Please enter holiday name",
  GroupNameMsg: "Please enter group name",
  ProjectNumberMsg: "Project number already exists",
  ProjectNameMsg: "Please enter project name",
  ProjectNameExistsMsg: "Project name already exists",
  ProjectDetailMsg: "Please enter project details",
  ProjectNumberErrMsg: "Please enter project number",
  ProjectTimezoneErrMsg: "Please select a time zone",
  SelectProjectForCopyMsg: "Please select a project to copy",
  EarlyStartMsg: "Click here to release the material ahead of schedule.",
  GroupUsersMsg: "Please select user",
  MaterialExists: "A material with this name already exists",
  CompanyProjectRole: "Please assign project role to the company",
  FieldDisabledDueToIntegrationMode:
    "Field cannot be edited as project is in Integration Mode",
  ActionDisabledDueToIntegrationMode:
    "Action cannot be performed as project is in Integration Mode",
  TimezoneFetchFailed: "Failed to fetch project timezone.",
  CompanyAlreadyLinkedToProject: "Company already linked to project",
  CompanyAddedSuccessMessage: "Company added successfully",
  CompanyAddedFailureMessage: "Company not added",
  CompanyInvitedSuccessMessage: "Company invited",
  CompanyInvitedFailureMessage: "Invite not sent",
  MaterialAccessDenied: "You do not have permission to view this material",
  SubmittalAccessDenied: "You do not have permission to view this submittal",
  SelectIntegrationType: "Please select integration type",
  FailedToGenerateACCAuthURL: "Could not generate Authorization URL",
  UnauthorizedPageAccess: "Sorry, you are not authorized to access this page.",
  NoLinksPresent: "No links present in the original.",
  reportExport: {
    errorMessage: "Risk report could not be downloaded due to some error.",
    submittalSuccessMessage:
      "Risk report is now available in your downloads folder."
  },
  comments: {
    fileSelectionLimitReached: "You can select upto $count$ attachments",
    addCommentFailed: "Failed to add comment",
    addAttachmentFailed: "Failed to upload attachment",
    fileDownloadStarted: "Please wait while the file is being downloaded"
  },
  specUploads: {
    pdfSelectionOnly: "Please select .PDF files only",
    specSectionCreationFailed: "Failed to create spec section",
    specSectionFileUploadFailed: "Failed to upload spec section",
    specFileUnderProcess:
      "File is being processed. You will be able to view the file once the process is completed."
  },
  invalidUrlMsg: "This link is invalid.",
  sessionExpiredMsg:
    "Link expired. Check your inbox for a new invite email. If you are unable to find an email, please contact the Subscription Admin to resend the invite.",
  deleteMaterialFailed: "Failed to delete Materials.",
  cannotChangeMDBTemplateWFStarted:
    "Cannot change template as material workflow is already started.",
  failedToApplyMDBTemplate: "Failed to apply template.",
  SessionExpired: "Session expired, redirecting to login",

  SomethingWentWrong: "Sorry, something went wrong. Please try in sometime.",
  NetworkError: {
    offlineMessage:
      "You appear to be offline. Please confirm that you have an internet connection.",
    internetError:
      "The internet isn't working properly. Will you please try again?"
  },
  ServerError: {
    default: "Sorry, something went wrong. Please try in sometime.",
    "404": "Server url is not correct. Please contact administrator."
  },
  templateNameRequiredValidation: "Template Name is required.",
  templateNameExists: "Template name already exists.",
  templateAlreadyUsed:
    "This template is currently in use and cannot be edited. Please create a copy and make updates there.",
  disableTemplateFailed: "Failed to disable the template.",
  integration: {
    integrationFailed: "Failed to add integration."
  },
  uniquessViolation: "Uniqueness violation.",
  linkingErrorMsg: "Linking was unsuccessful, please try again.",
  unLinkingErrorMsg: "Unlinking was unsuccessful, please try again.",
  bidPackgeNumber: "Enter bid package number.",
  bidPackgeTitle: "Enter bid package title.",
  designPackgeNumber: "Enter design package number.",
  designPackgeTitle: "Enter design package title.",
  submittalTitle: "Enter submittal title.",
  materialTitle: "Enter material title.",
  BidPackageTitleMsg: "Bid package title already exists.",
  DesignPackageTitleMsg: "Design package title already exists.",
  BidPackageNumberMsg: "Bid package number already exists.",
  DesignPackageNumberMsg: "Design package number already exists.",
  SubmittalTitleMsg: "Submittal title already exists.",
  MaterialTitleMsg: "Material title already exists.",
  FieldNotFoundMessage: "Something went wrong. Try again later.",
  DefaultFailureMessage: "Something has failed. Try again later.",
  EditingLinkingMessage: "Save the other changes before editing this."
};

export const SuccessMessages = {
  SuccessfullyUpdate: "Successfully Updated!",
  CompanyLinkedToProject: "Company successfully linked to project",
  IntegrationSuccess: "Project integrated successfully",
  deleteSuccess: "Deleted successfully",
  DBTemplateAppliedSuccess: "Template applied successfully.",
  DBDefaultTemplateSet: "Default template set successfully.",
  DBTemplateCopiedSuccessfully: "Template copied successfully.",
  DBTemplateDisabledSuccessfully: "Template disabled successfully.",
  DBTemplateEnabledSuccessfully: "Template enabled successfully.",
  integration: {
    integrationAdded: "Integration added."
  }
};

export const InfoMessages = {
  EmptySubmittalWorkflowMode:
    "Import a log or click New submittal to create a log entry.",
  ImportingSubmittals: "Please wait while we are importing the submittals.",
  EmptyACCSubmittalLogs: 'Please click on "Import Log" to add entries',
  FailedImportMsg: "File import was failed.Try after sometime.",
  exportReportToPdfTooltip:
    "Exporting this report may take some time. You can navigate to any other page, we will inform once the report has been downloaded.",
  deleteMaterialConfirmTitle:
    "Are you sure you want to delete the selected material(s)?",
  enterTemplateName: "Enter Template name for the duplicate",
  defaultTemplateChangeCOnfirmation:
    "Are you sure you want to make this the default template?",
  confirmMsgForMaterialTrackingOff:
    "The selected submittal has material tracking turned off. Do you wish to turn on Track Material and proceed with the linking?",
  confirmDisableMDBTemplate: "Are you sure you want to disable this template?",
  confirmEnableMDBTemplate: "Are you sure you want to enable this template?"
};

export const submittalLogFilterTitles: any = {
  due_in_2_week: "Actions due in 2 weeks",
  sc_due_in_2_week: "Actions due in 2 weeks",
  high_risk_due_in_2_week: "High risk and due in 2 weeks",
  sc_high_risk_due_in_2_week: "High risk and due in 2 weeks",
  low_risk_due_in_2_week: "Medium/Low risk and due in 2 weeks",
  sc_low_risk_due_in_2_week: "Medium/Low risk and due in 2 weeks",
  high_risk_due_later: "High risk and due later",
  sc_high_risk_due_later: "High risk and due later",
  low_risk_due_later: "Medium/Low risk and due later",
  sc_low_risk_due_later: "Medium/Low risk and due later",
  alert_new_submittals: "New submittals synced today",
  no_plan: "Planning due",
  "due-in-days-for-sc": "At high risk",
  overdue: "Overdue Submittals"
};

export const materialLogFilterTitles: any = {
  due_in_2_week: "Actions due in 2 weeks",
  sc_due_in_2_week: "Actions due in 2 weeks",
  high_risk_due_in_2_week: "High risk and due in 2 weeks",
  sc_high_risk_due_in_2_week: "High risk and due in 2 weeks",
  low_risk_due_in_2_week: "Medium/Low risk and due in 2 weeks",
  sc_low_risk_due_in_2_week: "Medium/Low risk and due in 2 weeks",
  high_risk_due_later: "High risk and due later",
  sc_high_risk_due_later: "High risk and due later",
  low_risk_due_later: "Medium/Low risk and due later",
  sc_low_risk_due_later: "Medium/Low risk and due later",
  no_plan: "Planning due",
  "due-in-days-for-sc": "At high risk",
  is_linked_void_submittal: "Materials Linked to Void Submittals",
  overdue: "Overdue Materials"
};

export const entityLogFilterTitles = (featureType: FeatureTypes): any => {
  switch (featureType) {
    case FeatureTypes.BID_PACKAGE:
      return {
        due_in_2_week: "Actions due in 2 weeks"
      };
      break;
    case FeatureTypes.DESIGN_PACKAGE:
      return {};
      break;
    case FeatureTypes.MATERIALS:
      return materialLogFilterTitles;
      break;
    case FeatureTypes.SUBMITTALS:
      return submittalLogFilterTitles;
      break;
    default:
      return {};
  }
};

export const noDocumentMessage = "No attachments added.";
export const noDocumentMessageUpload = "Click Add to upload an attachment";
export const noDocumentSelectMessage =
  "Please select a document from the left panel to view document.";

export const assigneesStatus = {
  account: "Account Created in ConstructiveIQ",
  project: "Project invite not accepted",
  submittal: "Submittal invite not accepted",
  newAssignee: "Project invite not accepted",
  present: "Present in ConstructiveIQ"
};

export const DialogTitles = {
  addCompany: "Add Company",
  addUser: "Add User",
  inviteUser: "Invite User"
};

export enum AcceptanceStatus {
  INVITED = 1,
  ACTIVE = 2,
  DEACTIVATED = 3,
  NOT_INVITED = 4
}

export enum ESubmittalStatus {
  CREATE = 1,
  SUBMIT = 2,
  REVIEW = 3,
  DONE = 4,
  GC_REVIEW = 5,
  EXTERNAL_REVIEW = 6,
  READY_FOR_DISTRIBUTION = 7,
  VOID = 8
}

export enum EWorkflowStatusDataBlock {
  WF_NOT_STARTED = "WF_NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  WF_COMPLETED = "WF_COMPLETED",
  VOID = "VOID"
}

export const SubmittalStatusToStrMap: any = {
  [ESubmittalStatus.CREATE]: "Pending SC Assignment",
  [ESubmittalStatus.SUBMIT]: "Pending SC Submission",
  [ESubmittalStatus.REVIEW]: "In Review",
  [ESubmittalStatus.DONE]: "Closed & Distributed",
  [ESubmittalStatus.GC_REVIEW]: "In GC Review",
  [ESubmittalStatus.EXTERNAL_REVIEW]: "In Design Team Review",
  [ESubmittalStatus.READY_FOR_DISTRIBUTION]: "In Final GC Review",
  [ESubmittalStatus.VOID]: "Void"
};

export const SubmittalWFStatusToStrMap: any = {
  [ESubmittalStatus.CREATE]: "Pending SC Assignment",
  [ESubmittalStatus.SUBMIT]: "SC Submittal Prep",
  [ESubmittalStatus.REVIEW]: "In Review",
  [ESubmittalStatus.GC_REVIEW]: "GC Review",
  [ESubmittalStatus.EXTERNAL_REVIEW]: "Design Review​",
  [ESubmittalStatus.READY_FOR_DISTRIBUTION]: "Final GC Review​",
  [ESubmittalStatus.VOID]: "Void​"
};

export const WeekdaysToNumberMap: any = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 0
};

export enum EUserTypes {
  GENERAL_CONTRACTOR = 1,
  SUBCONTRACTOR = 2,
  ARCHITECT = 3,
  ENGINEER = 4,
  OWNER = 5
}

export enum EFeaturePageId {
  SUBMITTAL = 1,
  MATERIAL = 2,
  BID_PACKAGE = 4,
  DESIGN_PACKAGE = 5
}

export const UserProjectRoles: any = {
  [EUserTypes.GENERAL_CONTRACTOR]: ["gc_project_admin", "gc_foreman"],
  [EUserTypes.SUBCONTRACTOR]: [
    "sc_project_admin",
    "sc_foreman",
    "gc_sc_project_admin",
    "gc_sc_foreman"
  ],
  [EUserTypes.ARCHITECT]: ["architect", "gc_sc_architect"],
  [EUserTypes.ENGINEER]: ["design_engineer", "gc_sc_design_engineer"],
  [EUserTypes.OWNER]: ["owner", "gc_sc_owner"]
};

export enum ECustomUserTypes {
  AllSCRoles = 1,
  AllGcEditorRoles = 2,
  AllGCUserRole = 3
}
export const CustomUserProjectRoles: any = {
  [ECustomUserTypes.AllSCRoles]: [
    "sc_project_admin",
    "sc_foreman",
    "gc_sc_project_admin",
    "gc_sc_foreman",
    "gc_sc_architect",
    "gc_sc_design_engineer",
    "gc_sc_owner"
  ],
  [ECustomUserTypes.AllGcEditorRoles]: [
    "gc_project_admin",
    "gc_sc_architect",
    "gc_sc_design_engineer",
    "gc_sc_owner",
    "gc_sc_project_admin"
  ],
  [ECustomUserTypes.AllGCUserRole]: ["gc_project_admin", "gc_foreman"]
};

export enum EUserRoleName {
  gc_project_admin,
  gc_foreman,
  sc_project_admin,
  sc_foreman,
  architect,
  design_engineer,
  owner,
  gc_sc_project_admin,
  gc_sc_foreman,
  gc_sc_architect,
  gc_sc_design_engineer,
  gc_sc_owner
}

export enum ProjectPermissionEnum {
  ViewProjectList,
  AddProjectUser,
  EditProjectDetail,
  CreateSubmittal,
  SubmittalWorkflow,
  InlineEditSubmittal,
  AddTradePartner,
  AddAttachment,
  AddEditCalendar,
  ViewLinkingPage,
  EditLinkingPage,
  LocationEdit,
  CreateDistributionGroup,
  EditDistributionGroup,
  CreateMaterial,
  InlineEditMaterialPrimaryFields,
  EditMaterialGeneralInfoAndParticipants,
  EditMaterialCharacteristics,
  ImportSchedule,
  MakeActiveSchedule,
  changeMaterialActualDate,
  changeMaterialPlannedDate,
  DeleteMaterialAttachment,
  EditMaterialDBOffset,
  ViewProjectReports,
  UploadSpecSectionFile,
  ViewDesignPage,
  CreateMaterialComment,
  EditDateBlockOffsetMaterial,
  EditDateBlockOffsetSubmittal,
  CreateMaterialCommentIfAssignee,
  ChangeMaterialTemplate,
  EditMaterialDBTemplate,
  BidPackageWrite,
  DesignPackageWrite,
  EditDateblockProjectedDate,
  RequestLeadTime,
  addProjectIntegration,
  EditScheduleDetails,
  changeProjectIntegration,
  CanSetLBSForMaterial,
  EditRiskThreshold,
  EditWorkflowTemplate,
  CanConfigureCustomReports
}

export enum ESubmittalMgmtModes {
  WORKFLOW_MODE = 1,
  INTEGRATION_MODE = 2
}

export const Regex = {
  phoneNumber: /^\+?\d+(?: \d+)*$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{12,}$/
};
// Old password pattern before task CIQ-4937: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-’/`~!#*$£@_%+=.,^&(){}[\]|;:'"”<>?\\]).{12,}$/

export const MaterialNotReleaseStatus = "Not Started";

export const MaterialOffsetFieldsMappingOldToNew: any = {
  material_PO_fabrication_offset: "offset_1",
  fabrication_duration_offset: "offset_2",
  lead_time_offset: "offset_3",
  on_site_storage_offset: "offset_4"
};

export enum RiskStates {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW"
}

export const ReportTitles = {
  submittalsRiskReport: "RISK REPORT",
  materialRiskReport: "RISK REPORT"
};

export const ConfigForMaterialCommentFiles = {
  allowedFileTypes: "*",
  maxSizeInMB: 5120
};

export enum ScheduleImpactStates {
  ACTIVITIES_UPDATED = "Activities Updated",
  ACTIVITIES_ADDED = "Activities Added",
  ACTIVITIES_DELETED = "Activities Deleted"
}

export enum IntegrationAuthProcessStatuses {
  PROCESSED = "PROCESSED",
  FAILED = "FAILED"
}

export const IntegrationSystemNameMap: any = {
  AUTODESK: "Autodesk Construction Cloud",
  PROCORE: "Procore",
  CMIC: "CMiC",
  EXTERNAL: "External",
  BIM360: "BIM360"
};

export const IntegrationAuthStates: any = {
  REAUTHORIZATION_REQUIRED: "REAUTHORIZATION_REQUIRED"
};

export enum AuditLogFeatures {
  SUBMITTAL_LOG = "SUBMITTAL_LOG",
  MATERIAL_LOG = "MATERIAL_LOG",
  SUBMITTAL_RISK_REPORT = "SUBMITTAL_RISK_REPORT",
  MATERIAL_RISK_REPORT = "MATERIAL_RISK_REPORT"
}

export enum AuditLogFeatureType {
  LOG_EXPORTED = "LOG_EXPORTED"
}

export enum EntityType {
  Submittal = "submittal",
  Material = "material",
  None = "not_defined"
}

export enum UserParticipationType {
  ASSIGNEE = 1,
  PRECONSTRUCTION_LEAD = 2,
  OPERATIONS_LEAD = 3,
  RESPONSIBLE_DESIGNER = 4,
  GC_REPRESENTATIVE = 5,
  SUBMITTER = 6,
  GC_REVIEWER = 7,
  DESIGN_REVIEWER = 8
}

export enum CompanyParticipationType {
  RESPONSIBLE_CONTRACTOR = 1,
  AWARDED_SUB_CONTRACTOR = 2,
  DESIGN_FIRM_CONTRACTOR = 3,
  RESPONSIBLE_DESIGN_FIRM = 3,
  BIDDING_SUB_CONTRACTOR = 4,
  GC_REVIEWER_VENDOR = 5,
  DESIGN_REVIEWER_VENDOR = 6
}

export const SidepanelStyles: { style: any } = {
  style: {
    right: 0,
    bottom: 0,
    top: 0,
    padding: 0,
    position: "absolute"
  }
};

export const ErrorTypes = {
  netWorkError: (errorStr: string) => {
    return errorStr === "Failed to fetch" && !isNetworkAvailable();
  },
  fieldNotFound: (errorStr: string) => {
    const regex = /field '([^']+)' not found in type: '([^']+)'/;
    return errorStr.match(regex);
  }
};
export enum EmailInviteStatus {
  REQUEST_SENT = "REQUEST_SENT"
}

export enum SourceNames {
  CONSTRUCTIVIQ = "ConstructivIQ"
}

export enum IntegrationLinkTooltipMsg {
  AUTODESK = "Open in Autodesk Construction Cloud",
  PROCORE = "Open in PROCORE"
}

export enum FeatureTypesIndex {
  SUBMITTAL = 1,
  MATERIAL = 2,
  BID_PACKAGE = 4,
  DESIGN_PACKAGE = 5
}

export enum GanttActivityTypes {
  Task = 0,
  Project = 1,
  Milestone = 2,
  MDB_Task = 3,
  SDB_Task = 4,
  Wps = 5
}

export enum Sources {
  ConstructivIQ = "ConstructivIQ",
  Acc = "ACC",
  Procore = "Procore"
}

export const priorities = [
  { label: "Low", value: "Low" },
  { label: "Normal", value: "Normal" },
  { label: "High", value: "High" }
];

export const SentryTags = {
  user_id: "CIQ.user_id",
  error_source: "CIQ.error_source"
};

export const SentryErrorSources = {
  graphql: "graphql",
  api: "api",
  frontend: "frontend",
  unknown: "unknown"
};

export const LINKED_ACTIVITIES_COLUMN_FILTER_LABELS = {
  ACTIVITY_LINKED: "Activity Linked",
  NO_ACTIVITIES_LINKED: "No Activities Linked",
  CRITICAL: "Critical",
  NOT_CRITICAL: "Not Critical"
};
